import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FileDrop } from 'react-file-drop';

export const RootStyled = styled('section')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 10,
});

export const IconContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 48,
  height: 48,
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    fontSize: 19,
    color: theme.palette.global.white,
    transition: 'fontSize 0.2s',
    '&:hover': {
      fontSize: 32,
    },
  },
}));

export const DropzoneStyled = styled(Box)(({ theme }) => ({
  width: '84%',
  height: 48,
  border: `1px dashed ${theme.palette.global.gray}`,
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: '#cccccccc',
  },
  '& p': {
    fontSize: 12,
  },
}));

// TODO: mesmo estilo do DropzoneStyled, considerar refatorar.
export const FileDropZoneDropzoneStyled = styled(FileDrop)(({ theme }) => ({
  width: '84%',
  height: 48,
  border: `1px dashed ${theme.palette.global.gray}`,
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: '#cccccccc',
  },
  '& p': {
    fontSize: 12,
  },
}));
